<template>
  <div class="cp-comments">
    <div class="cp-comments-header">
      <r-title type="subtitle-2">Комментарии</r-title>
    </div>
    <comments :id="id" :source_id="sourceId" />
  </div>
</template>

<script>
import Comments from "@/components/comments/comments";

export default {
  props: ["id", "source-id"],
  components: {
    Comments
  }
};
</script>

<style lang="scss">
.cp-comments {
  padding: 16px;
  flex: 1;

  &-header {
    margin-bottom: 8px;
  }
}
</style>
